import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleCustomSpinner, toggleSpinner } from 'apps/auth/actions/appAction';
import { addNextBills } from 'apps/auth/actions/historyAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { EmptyPage } from 'apps/auth/components/common/Layout/EmptyPage/EmptyPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { REQUEST_MONEY_BUTTON_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FILTER_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_REQUEST_CREATE } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logError } from 'apps/auth/helpers/clientLogger';

import HistoryRecord from './HistoryRecord';
import { TransactionsHistoryList } from '../styles';

const GET_NEXT_PAYMENTS = '/auth/request/history/next.page';

class RequestHistory extends React.Component {
    constructor(props) {
        super(props);

        this.addRecords = this.addRecords.bind(this);
        this.detectScrollToFooter = this.detectScrollToFooter.bind(this);
    }

    componentDidMount() {
        if (__isBrowser__) {
            document.addEventListener('scroll', this.detectScrollToFooter);
        }
    }

    componentWillUnmount() {
        if (__isBrowser__) {
            document.removeEventListener('scroll', this.detectScrollToFooter);
        }
    }

    detectScrollToFooter() {
        if (__isBrowser__) {
            const loadHeight = document.body.scrollHeight - window.innerHeight - 300;
            if (!this.props.loading && loadHeight < window.scrollY) {
                this.addRecords();
            }
        }
    }

    addRecords() {
        if (this.props.records.lastBillId !== -1) {
            this.props.toggleCustomSpinner(true);
            const form = this.props.forms[FILTER_FORM_NAME];
            apiFetchData(`${GET_NEXT_PAYMENTS}?lastId=${this.props.records.lastBillId}`, form ? form.fields : {})
                .then((json) => {
                    this.props.addNextBills(json?.extra?.billHistory);
                    this.props.toggleCustomSpinner(false);
                })
                .catch((e) => {
                    logError(e);
                    this.props.toggleCustomSpinner(false);
                });
        }
    }

    getMonthList(records) {
        let isFirst = true;
        return (
            <TransactionsHistoryList key={'list-' + records[0].id}>
                {records.map((record) => {
                    const li = <HistoryRecord record={record} addMonth={isFirst} key={`record-${record.id}`} />;
                    isFirst = false;
                    return li;
                })}
            </TransactionsHistoryList>
        );
    }

    render() {
        return (
            <>
                {this.props.records.bills && this.props.records.bills.map((payment) => this.getMonthList(payment.records, false))}
                {this.props.records && (!this.props.records.bills || this.props.records.bills.length === 0) && (
                    <EmptyPage iconName="ghost" emptyText={this.props.historyEmpty} />
                )}
                {this.props.canCreateBill && (
                    <FixedBottomPanel isPressedAboveMenu={true} isRightAligned={true} fullwidth={true}>
                        <Button
                            type="link"
                            raised={true}
                            href={AUTH_REQUEST_CREATE}
                            caption={this.props.newBill}
                            dataTestId="request-history-link-new-request"
                            onClick={() => {
                                amplitude.getInstance().logEvent(REQUEST_MONEY_BUTTON_CLICKED);
                                this.props.toggleSpinner(true);
                            }}
                        />
                    </FixedBottomPanel>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        forms: state.form,
        loading: state.app.isShowCustomSpinner,
        records: state.history.billHistory,
        historyEmpty: state.messages.pageMessages.historyEmpty,
        newBill: state.messages.pageMessages.newBill,
        canCreateBill: state.extra.canCreateBill,
    };
};
export default connect(mapStateToProps, { addNextBills, toggleCustomSpinner, toggleSpinner })(RequestHistory);
